/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import { Avatar, Divider, Tooltip } from "@mui/material";
import { IoCameraSharp } from "react-icons/io5";
import { RiEditLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineMailOutline } from "react-icons/md";
import { AuthState } from "store/ducks/auth/types";
import { RootStateOrAny, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as S from "./styles";
import {
  fCpf,
  fEmpty,
  FileUploadI,
  fTel,
  MetodoPagamento,
  SexoBiologico,
  TooltipThemes,
} from "../utils";
import { FileUploadModal } from "../components/FileUploadModal/fileUploadModal.component";
import { fetchAutonomo } from "../api/getAutonomo";
import { DadosPessoaisModal } from "../components/DadosPessoaisModal/dadosPessoaisModal.component";
import { EnderecoModal } from "../components/EnderecoModal/enderecoModal.component";
import PerfilSkeleton from "./skeleton.component";
import { CreciModal } from "../components/CreciModal/creciModal.component";
import { putFotoPerfilAutonomo } from "../api/putFotoPerfil";
import { MetodoPagamentoModal } from "../components/MetodoPagamentoModal/metodoPagamentoModal.component";

export const PerfilComponent = () => {
  const [modal, setModal] = useState({
    photo: false,
    data: false,
    address: false,
    creci: false,
    metodoDePagamento: false,
  });

  const router = useHistory();

  const { username } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { data: user, isLoading, isError, refetch } = fetchAutonomo(username);
  const isAutonomo = localStorage.getItem("isAutonomo") === "true";
  const isClt = user?.autonomoResponse?.isPj === false;

  const handlePhoto = (file: FileUploadI) => {
    putFotoPerfilAutonomo({
      idAutonomo: user?.autonomoResponse?.id,
      arquivo: file,
      authToken: user?.userAdResponse?.token,
    })
      .then(({ success, notifications }) => {
        if (success) {
          toast.success("Solicitação de alteração de foto enviada com sucesso");
        } else if (!success && notifications?.length > 0) {
          toast.info(notifications?.[0]?.message);
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Erro ao solicitar alteração de foto, por favor tente novamente"
        );
      });
  };

  const returnFilhos = (filhos: any[] | null): string => {
    if (filhos && filhos?.length > 0) {
      return `${filhos?.length}`;
    }
    return "Não";
  };

  if (isLoading) {
    return <PerfilSkeleton />;
  }

  if (isError || !isAutonomo) {
    router.push("/");
  }

  return (
    <S.Container>
      <S.Banner>
        <S.Photo>
          <Avatar
            alt={user?.autonomoResponse?.nomeImpressao}
            src={user?.autonomoResponse?.arquivoFoto?.url}
            sx={{ width: 180, height: 180 }}
          />
        </S.Photo>
      </S.Banner>

      <S.PerfilContainer>
        <S.SharedContainer>
          <S.SharedContainer
            style={{
              flexDirection: "column",
            }}
          >
            <S.SharedContainer>
              <S.PhotoContainer>
                <div id="photo-placeholder" />
                <div
                  className="change"
                  onClick={() => {
                    setModal((prev) => ({ ...prev, photo: true }));
                  }}
                >
                  <IoCameraSharp size={20} color="#2D5BFF" />
                  <p>Trocar Foto</p>
                </div>
              </S.PhotoContainer>

              <S.InfoContainer>
                <S.InfoBody>
                  <S.SharedContainer>
                    <h1 className="name">
                      {user?.autonomoResponse?.nomeImpressao}
                    </h1>
                  </S.SharedContainer>
                  <S.SharedContainer>
                    <p className="field">
                      {"Nome: "}
                      <span>{user?.autonomoResponse?.nomeCompleto}</span>
                    </p>
                  </S.SharedContainer>
                  <p className="field">
                    {"CPF: "}
                    <span>{fCpf(user?.autonomoResponse?.cpf)}</span>
                  </p>
                  <p className="field">
                    {"E-mail: "}
                    <span>
                      {fEmpty(user?.autonomoResponse?.emailComercial)}
                    </span>
                  </p>
                  <p className="field">
                    {"Posição: "}
                    <span>
                      {fEmpty(user?.autonomoResponse?.posicao?.descricao)}
                    </span>
                  </p>
                  <p className="field">
                    {"Imobiliária: "}
                    <span>
                      {fEmpty(
                        user?.autonomoResponse?.imobiliariaPrincipal?.nome
                      )}
                    </span>
                  </p>
                  <p className="field">
                    {"Bandeira: "}
                    <span>{fEmpty(user?.autonomoResponse?.bandeira)}</span>
                  </p>
                  <p className="field">
                    {"Sexo: "}
                    <span>
                      {SexoBiologico[user?.autonomoResponse?.sexo] ?? "--"}
                    </span>
                  </p>
                  <p className="field">
                    {"Data de Nasc.: "}
                    <span>
                      {user?.autonomoResponse?.dataNascimento
                        ? new Date(
                            user?.autonomoResponse?.dataNascimento
                          ).toLocaleDateString("pt-BR")
                        : "--/--/--"}
                    </span>
                  </p>
                </S.InfoBody>
              </S.InfoContainer>
            </S.SharedContainer>

            <Divider />

            <S.Footer>
              <S.InfoBody>
                <p className="field">
                  {"Endereço: "}
                  <span>
                    {fEmpty(user?.autonomoResponse?.endereco?.logradouro)}
                  </span>
                </p>
                <S.Bar />
                <p className="field">
                  {"Número: "}
                  <span>
                    {fEmpty(user?.autonomoResponse?.endereco?.numero)}
                  </span>
                </p>
                <S.Bar />
                <p className="field">
                  {"Bairro: "}
                  <span>
                    {fEmpty(user?.autonomoResponse?.endereco?.bairro)}
                  </span>
                </p>
                <S.Bar />
                <p className="field">
                  {"CEP: "}
                  <span>{fEmpty(user?.autonomoResponse?.endereco?.cep)}</span>
                </p>
                <S.Bar />
                <p className="field">
                  {"Cidade: "}
                  <span>
                    {fEmpty(user?.autonomoResponse?.endereco?.cidade)}
                  </span>
                </p>
                <S.Bar />
                <p className="field">
                  {"Estado: "}
                  <span>{fEmpty(user?.autonomoResponse?.endereco?.uf)}</span>
                </p>
                <S.Bar />
                <p className="field">
                  {"Complemento: "}
                  <span>
                    {fEmpty(user?.autonomoResponse?.endereco?.complemento)}
                  </span>
                </p>
              </S.InfoBody>
              {isClt ? null : (
                <div className="edit">
                  <RiEditLine
                    className="icon"
                    size={20}
                    onClick={() =>
                      setModal((prev) => ({ ...prev, address: true }))
                    }
                  />
                </div>
              )}
            </S.Footer>
          </S.SharedContainer>

          <S.CardContainer>
            <S.Creci>
              <div className="title">
                <h1>CRECI</h1>
                <RiEditLine
                  className="icon"
                  size={20}
                  onClick={() => setModal((prev) => ({ ...prev, creci: true }))}
                />
              </div>

              <div className="row mt">
                <p className="field">
                  {"Tipo: "}
                  <span>
                    {user?.autonomoResponse?.creci?.tipoCreci?.descricao}
                  </span>
                </p>
              </div>
              <div className="row mt">
                <p className="field">
                  {"N°: "}
                  <span>
                    {fEmpty(user?.autonomoResponse?.creci?.numeroCreci)}
                  </span>
                </p>
                <p className="field">
                  {"Venc.:"}
                  <span>
                    {user?.autonomoResponse?.creci?.dataVencimento
                      ? new Date(
                          user?.autonomoResponse?.creci?.dataVencimento
                        ).toLocaleDateString("pt-BR")
                      : "--/--/--"}
                  </span>
                </p>
              </div>
            </S.Creci>

            {user?.autonomoResponse?.bandeira?.toLowerCase() === "vivaz" && (
              <S.MetodoPagamento>
                <div className="title">
                  <h1>
                    {`Metodo de Pagamento${
                      user?.autonomoResponse?.autonomoMetodoDePagamento
                        ?.metodoDePagamento === MetodoPagamento.RPA
                        ? " (RPA)"
                        : user?.autonomoResponse?.autonomoMetodoDePagamento
                            ?.metodoDePagamento === MetodoPagamento.CNPJ
                        ? " (CNPJ)"
                        : ""
                    }`}
                  </h1>
                  <RiEditLine
                    className="icon"
                    size={20}
                    onClick={() =>
                      setModal((prev) => ({ ...prev, metodoDePagamento: true }))
                    }
                  />
                </div>

                {user?.autonomoResponse?.autonomoMetodoDePagamento
                  ?.metodoDePagamento === MetodoPagamento.RPA && (
                  <>
                    <div className="row mt">
                      <p className="field">
                        {"Nome do banco: "}
                        <span>
                          {user?.autonomoResponse?.autonomoMetodoDePagamento
                            ?.nomeDoBanco ?? "--"}
                        </span>
                      </p>
                    </div>
                    <div className="row mt">
                      <p className="field">
                        {"Agência: "}
                        <span>
                          {user?.autonomoResponse?.autonomoMetodoDePagamento
                            ?.agencia ?? "--"}
                        </span>
                      </p>
                    </div>
                    <div className="row mt">
                      <p className="field">
                        {"Conta Corrente: "}
                        <span>
                          {user?.autonomoResponse?.autonomoMetodoDePagamento
                            ?.contaCorrente ?? "--"}
                        </span>
                      </p>
                    </div>
                  </>
                )}

                {user?.autonomoResponse?.autonomoMetodoDePagamento
                  ?.metodoDePagamento === MetodoPagamento.CNPJ && (
                  <>
                    <div className="row mt">
                      <p className="field">
                        {"CNPJ: "}
                        <span>
                          {user?.autonomoResponse?.autonomoMetodoDePagamento
                            ?.cnpj ?? "--"}
                        </span>
                      </p>
                    </div>
                    <div className="row mt">
                      <p className="field">
                        {"Razão social: "}
                        <span>
                          {user?.autonomoResponse?.autonomoMetodoDePagamento
                            ?.razaoSocial ?? "--"}
                        </span>
                      </p>
                    </div>
                    <div className="row mt">
                      <p className="field">
                        {"Endereço fiscal: "}
                        <span>
                          {user?.autonomoResponse?.autonomoMetodoDePagamento
                            ?.enderecoFiscal ?? "--"}
                        </span>
                      </p>
                    </div>
                  </>
                )}
              </S.MetodoPagamento>
            )}

            <S.Contato>
              <div className="title-container">
                <h1>Dados Pessoais</h1>
                <RiEditLine
                  className="icon"
                  size={20}
                  onClick={() => setModal((prev) => ({ ...prev, data: true }))}
                />
              </div>

              {user?.autonomoResponse?.celularComercial &&
                user?.autonomoResponse?.celularComercial !== "N/I" && (
                  <div className="contact-icon">
                    <FaWhatsapp
                      style={{
                        color: "white",
                        background: "#2AA81A",
                        padding: 4,
                        borderRadius: "50%",
                      }}
                      size={20}
                    />
                    <Tooltip
                      arrow
                      title={fTel(user?.autonomoResponse?.celularComercial)}
                      componentsProps={TooltipThemes.gray}
                      placement="top"
                    >
                      <div>
                        <p>{fTel(user?.autonomoResponse?.celularComercial)}</p>
                      </div>
                    </Tooltip>
                  </div>
                )}
              {user?.autonomoResponse?.celularPessoal &&
                user?.autonomoResponse?.celularPessoal !== "N/I" && (
                  <div className="contact-icon">
                    <FaWhatsapp
                      style={{
                        color: "white",
                        background: "#2AA81A",
                        padding: 4,
                        borderRadius: "50%",
                      }}
                      size={20}
                    />
                    <Tooltip
                      arrow
                      title={fTel(user?.autonomoResponse?.celularPessoal)}
                      componentsProps={TooltipThemes.gray}
                      placement="top"
                    >
                      <div>
                        <p>{fTel(user?.autonomoResponse?.celularPessoal)}</p>
                      </div>
                    </Tooltip>
                  </div>
                )}
              <div className="contact-icon">
                <MdOutlineMailOutline
                  style={{
                    color: "#2196F3",
                    background: "white",
                    padding: 4,
                    borderRadius: "50%",
                  }}
                  size={20}
                />
                <Tooltip
                  arrow
                  title={fEmpty(user?.autonomoResponse?.emailContato)}
                  componentsProps={TooltipThemes.gray}
                  placement="top"
                >
                  <div>
                    <p>{fEmpty(user?.autonomoResponse?.emailContato)}</p>
                  </div>
                </Tooltip>
              </div>

              <div className="field mt">
                {"Filhos: "}
                <span style={{ maxWidth: 170 }}>
                  {returnFilhos(user?.autonomoResponse?.filhos)}
                </span>
              </div>
              <div className="field">
                {"Nome Emergência: "}
                <Tooltip
                  arrow
                  title={fEmpty(user?.autonomoResponse?.nomeEmergencia)}
                  componentsProps={TooltipThemes.gray}
                  placement="top"
                >
                  <div>
                    <span style={{ maxWidth: 170 }}>
                      {fEmpty(user?.autonomoResponse?.nomeEmergencia)}
                    </span>
                  </div>
                </Tooltip>
              </div>
              <div className="field">
                {"Telefone Emergência: "}
                <Tooltip
                  arrow
                  title={fTel(user?.autonomoResponse?.telefoneEmergencia)}
                  componentsProps={TooltipThemes.gray}
                  placement="top"
                >
                  <div>
                    <span style={{ maxWidth: 150 }}>
                      {fTel(user?.autonomoResponse?.telefoneEmergencia)}
                    </span>
                  </div>
                </Tooltip>
              </div>
            </S.Contato>
          </S.CardContainer>
        </S.SharedContainer>
      </S.PerfilContainer>

      {/* miscellaneous */}
      <FileUploadModal
        isOpen={modal.photo}
        onClose={() => {
          setModal((prev) => ({ ...prev, photo: false }));
        }}
        accept="image/png, image/jpeg, image/jpg"
        onChange={handlePhoto}
        shouldCrop
        cropData={{
          aspectRatio: 3 / 4,
          fixedRatio: true,
        }}
      />
      <DadosPessoaisModal
        isOpen={modal.data}
        onClose={() => {
          setModal((prev) => ({ ...prev, data: false }));
        }}
        user={user?.autonomoResponse}
        authToken={user?.userAdResponse?.token}
        refetch={refetch}
      />
      <EnderecoModal
        isOpen={modal.address}
        onClose={() => {
          setModal((prev) => ({ ...prev, address: false }));
        }}
        user={user?.autonomoResponse}
        authToken={user?.userAdResponse?.token}
        refetch={refetch}
      />
      <CreciModal
        isOpen={modal.creci}
        onClose={() => {
          setModal((prev) => ({ ...prev, creci: false }));
        }}
        user={user?.autonomoResponse}
        authToken={user?.userAdResponse?.token}
      />
      <MetodoPagamentoModal
        isOpen={modal.metodoDePagamento}
        onClose={() => {
          setModal((prev) => ({ ...prev, metodoDePagamento: false }));
        }}
        user={user?.autonomoResponse}
        authToken={user?.userAdResponse?.token}
      />
    </S.Container>
  );
};
